/* eslint-disable import/prefer-default-export */
import { DirectLinkDropLeadType } from "src/types/droplead";
import { logError } from "src/utils/logger";
import { clientHttpInstance } from "./http-client";

export const submitDirectLinkDropLead = async (
  droplead: DirectLinkDropLeadType
): Promise<void> => {
  try {
    const res = await clientHttpInstance.post<any>(
      "/drop-lead/submit",
      droplead
    );
    return res.data;
  } catch (error) {
    logError("[drop-lead-direct-link] send lead fail", {}, error);
    return error;
  }
};
